import { useEffect } from 'react';

/**
 * Hook to lock body overflow when a modal/overlay is active.
 * Saves and restores the original overflow value to support nested overlays.
 *
 * @param isActive - Whether the overflow lock should be active
 */
export function useBodyOverflowLock(isActive: boolean): void {
  useEffect(() => {
    if (!isActive) return;
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isActive]);
}
